<app-center-container
  [title]="title"
  [showClose]="true"
  closeTooltip="{{ 'exit' | translate | titlecase }}"
  (close)="closeForm()">

  @if (currentStep === 1) {
    <div class="slider_container">
      <span
        class="slider_icon"
        [ngClass]="{ 'slider_icon--disabled': isBackDisabled() }"
        matTooltip="{{ 'navigateBundleBack' | translate | titlecase }}"
        (click)="onBack()">
        <i class="fas fa-chevron-left"></i>
      </span>
      <span class="slider_title">{{ 'test' | translate }} #&nbsp;{{ currentBundleStep }}</span>
      <span
        class="slider_icon"
        [ngClass]="{ 'slider_icon--disabled': isForwardDisabled() }"
        matTooltip="{{ 'navigateBundleForward' | translate | titlecase }}"
        (click)="onForward()">
        <i class="fas fa-chevron-right"></i>
      </span>
    </div>
  }

  @if (form) {
    <form [formGroup]="form">
      @if (!newTestPromptShown) {
        <div [hidden]="currentStep !== 1">
          <div [hidden]="currentBundleStep !== 1 && isNew">
            @if (isResetItemsMessageDisplayed) {
              <app-info-box
                message="{{ 'resetItemsMessage' | translate }}"
                (onClose)="isResetItemsMessageDisplayed = false">
              </app-info-box>
            }
            <app-input-wrapper
              [control]="form.get('device')"
              label="{{ 'device' | translate }}">
              <mat-select
                class="form_control"
                formControlName="device"
                disableOptionCentering
                panelClass="dropdown"
                name="device"
                aria-label="{{ 'device' | translate }}">
                @for (device of devices; track device) {
                  <mat-option
                    [value]="device"
                    [disabled]="!device.available">
                    <span>
                      {{ device.name }}: {{ !device.available ? ('inUse' | translate) : device.code }}
                    </span>
                    @if (!!device.battery_level_headset_percentage && device.battery_level_headset_percentage <= 30) {
                      <span
                        matTooltip="{{ 'headsetBatteryTooltip' | translate }}">
                        <i class="fas fa-vr-cardboard"></i>
                      </span>
                    }
                    @if (!!device.battery_level_handpiece_percentage && device.battery_level_handpiece_percentage < 50) {
                      <span
                        matTooltip="{{ 'handpieceBatteryTooltip' | translate }}">
                        <i class="fas fa-gamepad"></i>
                      </span>
                    }
                  </mat-option>
                }
              </mat-select>
            </app-input-wrapper>
            <app-input-wrapper
              [control]="form.get('doctor')"
              label="{{ 'doctorsName' | translate }}">
              <mat-select
                class="form_control"
                formControlName="doctor"
                disableOptionCentering
                panelClass="dropdown"
                name="doctor"
                aria-label="{{ 'doctorsName' | translate }}">
                @for (doctor of doctors; track doctor) {
                  <mat-option [value]="doctor.id">
                    {{ doctor.first_name }} {{ doctor.last_name }}
                  </mat-option>
                }
              </mat-select>
            </app-input-wrapper>
            @if (!authService.isTechallAdmin) {
              <app-input-wrapper
                [control]="form.get('operator')"
                label="{{ 'operatorsName' | translate }}">
                <mat-select
                  class="form_control"
                  formControlName="operator"
                  disableOptionCentering
                  panelClass="dropdown"
                  name="operator"
                  aria-label="{{ 'operatorsName' | translate }}">
                  @for (operator of operators; track operator) {
                    <mat-option [value]="operator.id">
                      {{ operator.first_name }} {{ operator.last_name }}
                    </mat-option>
                  }
                </mat-select>
              </app-input-wrapper>
            }
          </div>
          <app-input-wrapper
            [control]="form.get('group')"
            label="{{ 'testGroup' | translate }}">
            <mat-select
              class="form_control"
              formControlName="group"
              disableOptionCentering
              panelClass="dropdown"
              name="group"
              aria-label="{{ 'testGroup' | translate }}">
              @for (testGroup of displayedTestGroups; track testGroup) {
                <mat-option [value]="testGroup.value">
                  @if (testGroup.value === 'CSUITE') {
                    <i class="fa fa-layer-group"></i>
                  }
                  <span>{{ testGroup.name }}</span>
                </mat-option>
              }
            </mat-select>
          </app-input-wrapper>
          @if (testFormService.isGroupVisualHintDisplayed && !selectedTestGroup) {
            <app-info-box
              message="{{ 'resetGroupSelection' | translate }}"
              (onClose)="testFormService.hideGroupVisualHint()">
            </app-info-box>
          }
          @if (displayedTestStrategies?.length > 1) {
            <app-input-wrapper
              [control]="form.get('strategy')"
              label="{{ 'testStrategy' | translate }}">
              <mat-select
                class="form_control"
                formControlName="strategy"
                disableOptionCentering
                panelClass="dropdown"
                name="strategy"
                aria-label="{{ 'testStrategy' | translate }}">
                @for (testStrategy of displayedTestStrategies; track testStrategy) {
                  <mat-option
                    [value]="testStrategy.value"
                    [ngClass]="{'hidden--force': testStrategy.value === 'BLUE_PUPILLOMETRY'}">
                    {{ testStrategy.name }}
                  </mat-option>
                }
              </mat-select>
            </app-input-wrapper>
          }
          @if (testFormService.isStrategyVisualHintDisplayed && !selectedTestStrategy) {
            <app-info-box
              message="{{ 'resetStrategySelection' | translate }}"
              (onClose)="testFormService.hideStrategyVisualHint()">
            </app-info-box>
          }
          @if (displayedTestProtocols?.length > 1) {
            <app-input-wrapper
              [control]="form.get('protocol')"
              label="{{ 'testProtocol' | translate }}">
              <mat-select
                class="form_control"
                formControlName="protocol"
                disableOptionCentering
                panelClass="dropdown"
                name="protocol"
                aria-label="{{ 'testProtocol' | translate }}">
                @for (testProtocol of displayedTestProtocols; track testProtocol) {
                  <mat-option
                    [value]="testProtocol.value"
                    [ngClass]="{'hidden--force': testProtocol.value === 'QUADRANT'}">
                    {{ testProtocol.name }}
                  </mat-option>
                }
              </mat-select>
            </app-input-wrapper>
          }
          @if (testFormService.isTestWithEyeSelection(selectedTestGroup, selectedTestStrategy, selectedDevice, selectedMonocular)) {
            <app-input-wrapper
              [control]="form.get('eye')"
              label="{{ testFormService.isEyeMovableTest(selectedTestGroup) ? ('eyeMovable' | translate) : ('eyes' | translate) }}">
              <div class="radio_group">
                @if (!testFormService.isSingleEyeTest(selectedTestGroup, selectedTestStrategy, selectedDevice)) {
                  <input
                    id="eyes-both"
                    class="radio_input"
                    type="radio"
                    formControlName="eye"
                    (change)="onEyeChange()"
                    value="both">
                    <label class="radio_label" for="eyes-both">
                      <div class="radio_button"></div>
                      <div class="radio_text">{{ 'both' | translate }}</div>
                    </label>
                  }
                  <input
                    id="eyes-od"
                    class="radio_input"
                    type="radio"
                    formControlName="eye"
                    (change)="onEyeChange()"
                    value="OD">
                    <label class="radio_label" for="eyes-od">
                      <div class="radio_button"></div>
                      <div class="radio_text">{{ 'right' | translate | titlecase }}</div>
                    </label>
                    <input
                      id="eyes-os"
                      class="radio_input"
                      type="radio"
                      formControlName="eye"
                      (change)="onEyeChange()"
                      value="OS">
                      <label class="radio_label" for="eyes-os">
                        <div class="radio_button"></div>
                        <div class="radio_text">{{ 'left' | translate | titlecase }}</div>
                      </label>
                    </div>
                  </app-input-wrapper>
                }
                @if (testFormService.isTestWithEarSelection(selectedTestGroup, selectedTestStrategy)) {
                  <app-input-wrapper
                    [control]="form.get('ear')"
                    label="{{ 'startEar' | translate }}">
                    <div class="radio_group">
                      <input
                        id="ears-right"
                        class="radio_input"
                        type="radio"
                        formControlName="ear"
                        value="RIGHT">
                        <label class="radio_label" for="ears-right">
                          <div class="radio_button"></div>
                          <div class="radio_text">{{ 'right' | translate | titlecase }}</div>
                        </label>
                        <input
                          id="ears-left"
                          class="radio_input"
                          type="radio"
                          formControlName="ear"
                          value="LEFT">
                          <label class="radio_label" for="ears-left">
                            <div class="radio_button"></div>
                            <div class="radio_text">{{ 'left' | translate | titlecase }}</div>
                          </label>
                        </div>
                      </app-input-wrapper>
                    }
                    @if (testFormService.isTestWithNonConvergenceMonocular(selectedTestGroup, selectedTestStrategy, selectedEye, selectedDevice)) {
                      <app-input-wrapper
                        [control]="form.get('monocular')">
                        <input
                          type="checkbox"
                          class="checkbox_input"
                          formControlName="monocular"
                          name="monocular-checkbox"
                          (change)="onMonocularCheckboxChange()"
                          id="monocular">
                          <label
                            for="monocular"
                            class="checkbox_label"
                            [ngClass]="{ 'checkbox_label--error': form.get('monocular').errors && form.get('monocular').touched }">
                            {{ 'monocular' | translate | titlecase }}
                          </label>
                        </app-input-wrapper>
                      }
                      @if (testFormService.isTestWithOuOnly(selectedTestGroup, selectedTestStrategy, selectedTestProtocol)) {
                        <app-input-wrapper
                          [control]="form.get('ou_only')">
                          <input
                            type="checkbox"
                            class="checkbox_input"
                            formControlName="ou_only"
                            name="ou-only-checkbox"
                            (change)="onOuOnlyCheckboxChange()"
                            id="ou_only">
                            <label
                              for="ou_only"
                              class="checkbox_label"
                              [ngClass]="{ 'checkbox_label--error': form.get('ou_only').errors && form.get('ou_only').touched }">
                              {{ 'ouOnly' | translate }}
                            </label>
                          </app-input-wrapper>
                        }
                      @if (testFormService.isMonocularConfrontationCheckboxShown(selectedTestGroup, selectedDevice) && !hasConvergenceTestBeforeCurrentStep(currentBundleStep - 1)) {
                        <app-input-wrapper
                          [control]="form.get('monocular_confrontation')">
                          <input
                            type="checkbox"
                            class="checkbox_input"
                            formControlName="monocular_confrontation"
                            name="monocular-confrontation"
                            id="monocular-confrontation">
                            <label
                              for="monocular-confrontation"
                              class="checkbox_label">
                              {{ 'monocularConfrontation' | translate | titlecase }}
                            </label>
                          </app-input-wrapper>
                        }
                        @if (testFormService.isMonocularColorCheckboxShown(selectedTestGroup)) {
                          <app-input-wrapper
                            [control]="form.get('monocular_color')">
                            <input
                              type="checkbox"
                              class="checkbox_input"
                              formControlName="monocular_color"
                              name="monocular-color"
                              id="monocular-color">
                              <label
                                for="monocular-color"
                                class="checkbox_label">
                                {{ 'monocularColor' | translate | titlecase }}
                              </label>
                              <br>
                              </app-input-wrapper>
                            }
                            @if (testFormService.isTestWithCorrection(selectedTestGroup, selectedTestStrategy, test)) {
                              <app-input-wrapper
                                [control]="form.get('with_correction')">
                                <input
                                  type="checkbox"
                                  class="checkbox_input"
                                  formControlName="with_correction"
                                  id="with_correction"
                                  name="with_correction">
                                  <label
                                    for="with_correction"
                                    class="checkbox_label"
                                    [ngClass]="{ 'checkbox_label--error': form.get('with_correction').errors && form.get('with_correction').touched }">
                                    {{ 'withCorrection' | translate }}
                                  </label>
                                </app-input-wrapper>
                              }
                              @if (testFormService.isTestWithCorrectionType(selectedTestGroup, test)) {
                                <app-input-wrapper
                                  [control]="form.get('correction_type')"
                                  label="{{ 'correctionType' | translate }}">
                                  <mat-select
                                    class="form_control"
                                    formControlName="correction_type"
                                    disableOptionCentering
                                    panelClass="dropdown"
                                    name="correction_type"
                                    aria-label="{{ 'correctionType' | translate }}">
                                    <mat-option [value]="'none'">{{ 'none' | translate }}</mat-option>
                                    @for (type of correctionTypes; track type) {
                                      <mat-option [value]="type.id">{{ type.name?.toLowerCase() | translate | titlecase }}</mat-option>
                                    }
                                  </mat-select>
                                </app-input-wrapper>
                              }
                              @if (testFormService.isTestWithContrast(selectedTestGroup, selectedTestStrategy)) {
                                <app-input-wrapper
                                  [control]="form.get('contrast')"
                                  label="{{ 'contrast' | translate }}">
                                  <mat-select
                                    class="form_control"
                                    formControlName="contrast"
                                    disableOptionCentering
                                    panelClass="dropdown"
                                    name="contrast"
                                    aria-label="{{ 'contrast' | translate }}">
                                    @for (c of testFormService.getContrasts(selectedTestGroup, selectedTestStrategy); track c) {
                                      <mat-option [value]="c">{{ c }}%</mat-option>
                                    }
                                  </mat-select>
                                </app-input-wrapper>
                              }
                              @if (testFormService.isTestWithIntensity(selectedTestStrategy, selectedTestProtocol, selectedDevice)) {
                                <app-input-wrapper
                                  [control]="form.get('supra_t_intensity')"
                                  label="{{ testFormService.isTestWithSupraIntensity(selectedTestStrategy) ? ('supraIntensity' | translate) : ('estermanIntensity' | translate) }}">
                                  <mat-select
                                    class="form_control"
                                    name="supra_t_intensity"
                                    formControlName="supra_t_intensity"
                                    disableOptionCentering
                                    panelClass="dropdown"
                                    aria-label="{{ testFormService.isTestWithSupraIntensity(selectedTestStrategy) ? ('supraIntensity' | translate) : ('estermanIntensity' | translate) }}">
                                    @for (intensity of supraTIntensities; track intensity) {
                                      <mat-option [value]="intensity.value">
                                        {{ intensity.label | translate | titlecase }}
                                      </mat-option>
                                    }
                                  </mat-select>
                                </app-input-wrapper>
                              }
                              @if (testFormService.isGoldmanSizeDisplayed(selectedTestStrategy, selectedDevice)) {
                                <app-input-wrapper
                                  [control]="form.get('goldman_size')"
                                  label="{{ 'goldmanSize' | translate }}">
                                  <mat-select
                                    class="form_control"
                                    formControlName="goldman_size"
                                    disableOptionCentering
                                    panelClass="dropdown"
                                    name="goldman_size"
                                    aria-label="{{ 'goldmanSize' | translate }}">
                                    @for (goldmanSize of selectedTestStrategy.goldman_size; track goldmanSize) {
                                      <mat-option
                                        [value]="goldmanSize">
                                        {{ testFormService.getGoldmanSizeLabel(goldmanSize) }}
                                      </mat-option>
                                    }
                                  </mat-select>
                                </app-input-wrapper>
                              }
                              @if (testFormService.isTestWithStimulusType(selectedTestStrategy)) {
                                <app-input-wrapper
                                  [control]="form.get('stimulus_type')"
                                  label="{{ 'stimulusType' | translate }}">
                                  <mat-select
                                    class="form_control"
                                    name="stimulus_type"
                                    formControlName="stimulus_type"
                                    disableOptionCentering
                                    panelClass="dropdown"
                                    aria-label="{{ 'stimulusType' | translate }}">
                                    @for (stimulusType of stimulusTypes; track stimulusType) {
                                      <mat-option [value]="stimulusType">
                                        {{ stimulusType }}
                                      </mat-option>
                                    }
                                  </mat-select>
                                </app-input-wrapper>
                              }
                              @if (testFormService.isTestWithApdStimulationTime(selectedTestStrategy)) {
                                <app-input-wrapper
                                  [control]="form.get('apd_stimulation_time')"
                                  label="{{ 'apdStimulationTime' | translate }}">
                                  <mat-select
                                    class="form_control"
                                    name="apd_stimulation_time"
                                    formControlName="apd_stimulation_time"
                                    disableOptionCentering
                                    panelClass="dropdown"
                                    aria-label="{{ 'apdStimulationTime' | translate }}">
                                    @for (stimulationTime of apdStimulationTimes; track stimulationTime) {
                                      <mat-option [value]="stimulationTime">
                                        {{ stimulationTime }}
                                      </mat-option>
                                    }
                                  </mat-select>
                                </app-input-wrapper>
                              }
                              @if (testFormService.isTestWithControlType(selectedTestGroup, selectedTestStrategy, selectedTestProtocol, selectedLanguage)) {
                                @if (isVoiceWarningDisplayed && form.get('control_type')?.value && (selectedTestGroup?.value !== 'COLOR_VISION')) {
                                  <app-info-box
                                    message="{{ 'voiceSelectionMessage' | translate }}"
                                    (onClose)="isVoiceWarningDisplayed = false">
                                  </app-info-box>
                                }
                                <app-input-wrapper
                                  [control]="form.get('control_type')"
                                  label="{{ 'controlType' | translate }}">
                                  <mat-select
                                    class="form_control"
                                    name="control_type"
                                    aria-label="{{ 'controlType' | translate }}"
                                    formControlName="control_type"
                                    disableOptionCentering
                                    panelClass="dropdown"
                                    (selectionChange)="onControlTypeChange($event.value)">
                                    @for (type of controlTypes; track type) {
                                      <mat-option [value]="type.id">
                                        {{ type.name?.toLowerCase() | translate | titlecase }}
                                      </mat-option>
                                    }
                                  </mat-select>
                                </app-input-wrapper>
                              }
                              @if (testFormService.isTestWithOcclusionTime(selectedTestGroup, selectedTestStrategy)) {
                                <app-input-wrapper
                                  [control]="form.get('occlusion_time')"
                                  label="{{ 'occlusionTime' | translate }}">
                                  <input
                                    name="occlusion_time"
                                    class="form_control"
                                    type="number"
                                    min="1"
                                    max="10"
                                    formControlName="occlusion_time">
                                  </app-input-wrapper>
                                }
                                @if (testFormService.isTestWithPositions(selectedTestStrategy)) {
                                  <app-input-wrapper
                                    [control]="form.get('cover_directions')"
                                    label="{{ 'testingPositions' | translate }}">
                                    <mat-select
                                      class="form_control"
                                      formControlName="cover_directions"
                                      disableOptionCentering
                                      panelClass="dropdown"
                                      name="cover_directions"
                                      aria-label="{{ 'testingPositions' | translate }}">
                                      @for (position of testingPositions; track position) {
                                        <mat-option [value]="position.value">
                                          {{ position.label | translate }}
                                        </mat-option>
                                      }
                                    </mat-select>
                                  </app-input-wrapper>
                                }
                                @if (testFormService.isTestWithDefaultDigitalOcclusion(selectedTestStrategy)) {
                                  <app-input-wrapper
                                    [control]="form.get('cover_digitally_occluded')">
                                    <input
                                      type="checkbox"
                                      class="checkbox_input"
                                      formControlName="cover_digitally_occluded"
                                      name="cover_digitally_occluded"
                                      id="cover_digitally_occluded">
                                      <label
                                        for="cover_digitally_occluded"
                                        class="checkbox_label"
                                        [ngClass]="{ 'checkbox_label--error': form.get('cover_digitally_occluded').errors && form.get('cover_digitally_occluded').touched }">
                                        {{ 'coverDigitallyOccluded' | translate }}
                                      </label>
                                    </app-input-wrapper>
                                  }
                                  @if (testFormService.isTestWithFoveal(selectedTestStrategy, selectedDevice)) {
                                    <app-input-wrapper
                                      [control]="form.get('test_foveal_sensitivity')">
                                      <input
                                        type="checkbox"
                                        class="checkbox_input"
                                        formControlName="test_foveal_sensitivity"
                                        name="test_foveal_sensitivity"
                                        id="test_foveal_sensitivity">
                                        <label
                                          for="test_foveal_sensitivity"
                                          class="checkbox_label"
                                          [ngClass]="{ 'checkbox_label--error': form.get('test_foveal_sensitivity').errors && form.get('test_foveal_sensitivity').touched }">
                                          {{ 'testFovealSensitivity' | translate }}
                                        </label>
                                      </app-input-wrapper>
                                    }
                                    @if (testFormService.isTestWithSkipCalibration(selectedTestGroup, selectedTestStrategy, selectedTestProtocol, selectedControlType)) {
                                      <app-input-wrapper
                                        [control]="form.get('skip_calibration')">
                                        <input
                                          type="checkbox"
                                          class="checkbox_input"
                                          formControlName="skip_calibration"
                                          name="skip_calibration"
                                          id="skip_calibration">
                                          <label
                                            for="skip_calibration"
                                            class="checkbox_label"
                                            [ngClass]="{ 'checkbox_label--error': form.get('skip_calibration').errors && form.get('skip_calibration').touched }">
                                            {{ 'skipCalibration' | translate | titlecase }}
                                          </label>
                                        </app-input-wrapper>
                                      }
                                      @if (isDisableEyeTrackingDisplayed()) {
                                        <app-input-wrapper
                                          [control]="form.get('disable_eye_tracking')">
                                          <input
                                            type="checkbox"
                                            class="checkbox_input"
                                            formControlName="disable_eye_tracking"
                                            name="disable_eye_tracking"
                                            id="disable_eye_tracking">
                                            <label
                                              for="disable_eye_tracking"
                                              class="checkbox_label"
                                              [ngClass]="{ 'checkbox_label--error': form.get('disable_eye_tracking').errors && form.get('disable_eye_tracking').touched }">
                                              {{ 'disableEyeTracking' | translate | titlecase }}
                                            </label>
                                          </app-input-wrapper>
                                        }
                                        @if (testFormService.isTestWithSkipEyeTrackingCalibration(selectedTestGroup, selectedTestStrategy)) {
                                          <app-input-wrapper
                                            [control]="form.get('skip_eye_tracking_calibration')">
                                            <input
                                              type="checkbox"
                                              class="checkbox_input"
                                              formControlName="skip_eye_tracking_calibration"
                                              name="skip_eye_tracking_calibration"
                                              id="skip_eye_tracking_calibration">
                                              <label
                                                for="skip_eye_tracking_calibration"
                                                class="checkbox_label"
                                                [ngClass]="{ 'checkbox_label--error': form.get('skip_eye_tracking_calibration').errors && form.get('skip_eye_tracking_calibration').touched }">
                                                {{ 'skipEyeTrackingCalibration' | translate | titlecase }}
                                              </label>
                                            </app-input-wrapper>
                                          }
                                          <div [hidden]="currentBundleStep !== 1 && isNew">
                                            @if (testFormService.isTestBundleWithLanguage(selectedDevice)) {
                                              <app-input-wrapper
                                                [control]="form.get('language')"
                                                infoIconText="{{ testFormService.hasVoiceControlTypeSelected(form, controlTypes) ? ('languageFormVoiceInfoMessage' | translate) : null }}"
                                                label="{{ 'language' | translate }}">
                                                <mat-select
                                                  class="form_control"
                                                  formControlName="language"
                                                  disableOptionCentering
                                                  panelClass="dropdown"
                                                  (selectionChange)="onLanguageChange($event.value)"
                                                  name="language"
                                                  aria-label="{{ 'language' | translate }}">
                                                  @for (language of displayedLanguages; track language) {
                                                    <mat-option [value]="language.value">
                                                      {{ language.name | translate | titlecase }}
                                                    </mat-option>
                                                  }
                                                </mat-select>
                                              </app-input-wrapper>
                                              @if (testFormService.isLanguageVisualHintDisplayed) {
                                                <app-info-box
                                                  message="{{ 'resetLanguageSelection' | translate }}"
                                                  (onClose)="testFormService.hideLanguageVisualHint()">
                                                </app-info-box>
                                              }
                                            }
                                            @if (testFormService.isTestWithDisablePause(selectedDevice, selectedTestStrategy)) {
                                              <app-input-wrapper
                                                [control]="form.get('disable_pause')">
                                                <input
                                                  type="checkbox"
                                                  class="checkbox_input"
                                                  formControlName="disable_pause"
                                                  id="disable_pause"
                                                  name="disable_pause">
                                                  <label
                                                    for="disable_pause"
                                                    class="checkbox_label"
                                                    [ngClass]="{ 'checkbox_label--error': form.get('disable_pause').errors && form.get('disable_pause').touched }">
                                                    {{ 'disablePause' | translate }}
                                                  </label>
                                                </app-input-wrapper>
                                              }
                                            </div>
                                            @if (!preferences?.always_use_subtitles
                                              && testFormService.isTestWithSubtitles(selectedDevice, selectedLanguage, selectedTestGroup, selectedTestStrategy)) {
                                              <app-input-wrapper
                                                [control]="form.get('subtitles')">
                                                <input
                                                  type="checkbox"
                                                  class="checkbox_input"
                                                  formControlName="subtitles"
                                                  name="subtitles"
                                                  id="subtitles">
                                                  <label
                                                    for="subtitles"
                                                    class="checkbox_label"
                                                    [ngClass]="{ 'checkbox_label--error': form.get('subtitles').errors && form.get('subtitles').touched }">
                                                    {{ 'useSubtitles' | translate | titlecase }}
                                                  </label>
                                                </app-input-wrapper>
                                              }
                                              @if (testFormService.isTestWithIncreasedSubtitles(selectedDevice, selectedLanguage, selectedSubtitles, selectedTestGroup, selectedTestStrategy)) {
                                                <app-input-wrapper
                                                  [control]="form.get('subtitle_increase_text_size')">
                                                  <input
                                                    type="checkbox"
                                                    class="checkbox_input"
                                                    formControlName="subtitle_increase_text_size"
                                                    name="subtitle_increase_text_size"
                                                    id="subtitle_increase_text_size">
                                                    <label
                                                      for="subtitle_increase_text_size"
                                                      class="checkbox_label"
                                                      [ngClass]="{ 'checkbox_label--error': form.get('subtitle_increase_text_size').errors && form.get('subtitle_increase_text_size').touched }">
                                                      {{ 'useIncreasedSubtitles' | translate | titlecase }}
                                                    </label>
                                                  </app-input-wrapper>
                                                }
                                                @if (testFormService.isTestWithTutorial(selectedTestGroup, selectedTestStrategy, selectedTestProtocol)) {
                                                  <app-input-wrapper
                                                    [control]="form.get('skip_tutorial')">
                                                    <input
                                                      type="checkbox"
                                                      class="checkbox_input"
                                                      formControlName="skip_tutorial"
                                                      (change)="onSkipTutorialChange($event)"
                                                      id="skip_tutorial"
                                                      name="skip_tutorial">
                                                      <label
                                                        for="skip_tutorial"
                                                        class="checkbox_label"
                                                        [ngClass]="{ 'checkbox_label--error': form.get('skip_tutorial').errors && form.get('skip_tutorial').touched }">
                                                        {{ 'skipTutorial' | translate }}
                                                      </label>
                                                    </app-input-wrapper>
                                                  }
                                                  @if (isConvergenceSectionVisible()) {
                                                    @if (testFormService.isBothEyesSelected(form)) {
                                                      <app-input-wrapper [control]="form.get('skip_convergence_testing')">
                                                        <input
                                                          type="checkbox"
                                                          class="checkbox_input"
                                                          formControlName="skip_convergence_testing"
                                                          (change)="onSkipConvergenceChange($event)"
                                                          id="skip_convergence_testing"
                                                          name="skip_convergence_testing">
                                                          <label
                                                            for="skip_convergence_testing"
                                                            class="checkbox_label"
                                                            [ngClass]="{ 'checkbox_label--error': form.get('skip_convergence_testing').errors && form.get('skip_convergence_testing').touched }">
                                                            {{ 'skipConvergenceTesting' | translate }}
                                                          </label>
                                                        </app-input-wrapper>
                                                        @if (form.get('skip_convergence_testing').value) {
                                                          <app-input-wrapper
                                                            [control]="form.get('monocular')"
                                                            [isIndent]="true">
                                                            <div class="radio_group radio_group--vertical-mobile">
                                                              <input
                                                                id="monocular-on"
                                                                class="radio_input"
                                                                type="radio"
                                                                formControlName="monocular"
                                                                [value]="true">
                                                                <label class="radio_label" for="monocular-on">
                                                                  <div class="radio_button"></div>
                                                                  <div class="radio_text">{{ 'monocularOn' | translate }}</div>
                                                                </label>
                                                                <input
                                                                  id="monocular-off"
                                                                  class="radio_input"
                                                                  type="radio"
                                                                  formControlName="monocular"
                                                                  [value]="false">
                                                                  <label class="radio_label" for="monocular-off">
                                                                    <div class="radio_button"></div>
                                                                    <div class="radio_text">{{ 'monocularOff' | translate }}</div>
                                                                  </label>
                                                                </div>
                                                              </app-input-wrapper>
                                                            }
                                                          } @else {
                                                            <br>
                                                              <app-input-wrapper
                                                                [control]="form.get('monocular')"
                                                                label="{{ 'binocularFixationPoints' | translate }}"
                                                                [forceMinimized]="true">
                                                                <div class="radio_group radio_group--vertical-mobile">
                                                                  <input
                                                                    id="binocular-on"
                                                                    class="radio_input"
                                                                    type="radio"
                                                                    formControlName="monocular"
                                                                    [value]="false">
                                                                    <label class="radio_label" for="binocular-on">
                                                                      <div class="radio_button"></div>
                                                                      <div class="radio_text">{{ 'ON' | translate }}</div>
                                                                    </label>
                                                                    <input
                                                                      id="binocular-off"
                                                                      class="radio_input"
                                                                      type="radio"
                                                                      formControlName="monocular"
                                                                      selected
                                                                      [value]="true">
                                                                      <label class="radio_label" for="binocular-off">
                                                                        <div class="radio_button"></div>
                                                                        <div class="radio_text">{{ 'OFF' | translate }}</div>
                                                                      </label>
                                                                    </div>
                                                                  </app-input-wrapper>
                                                                }
                                                              }
                                                              @if (testFormService.isTestWithShortTutorial(selectedTestGroup, selectedTestStrategy, selectedTestProtocol, selectedLanguage)) {
                                                                <app-input-wrapper
                                                                  [control]="form.get('use_short_tutorial')">
                                                                  <input
                                                                    type="checkbox"
                                                                    class="checkbox_input"
                                                                    formControlName="use_short_tutorial"
                                                                    (change)="onShortTutorialChange($event)"
                                                                    name="use_short_tutorial"
                                                                    id="use_short_tutorial">
                                                                    <label
                                                                      for="use_short_tutorial"
                                                                      class="checkbox_label"
                                                                      [ngClass]="{ 'checkbox_label--error': form.get('use_short_tutorial').errors && form.get('use_short_tutorial').touched }">
                                                                      {{ 'useShortTutorial' | translate }}
                                                                    </label>
                                                                  </app-input-wrapper>
                                                                }
                                                                @if (isNew) {
                                                                  <button
                                                                    type="button"
                                                                    class="button button--primary form_button"
                                                                    (click)="onBundleItemSave('forward')"
                                                                    [disabled]="!form.valid">
                                                                    <span class="regular">{{ 'next' | translate }}</span>
                                                                  </button>
                                                                }
                                                              </div>
                                                            } @else {
                                                              <div [hidden]="currentStep !== 1">
                                                                {{ testBundlesService.canAddTestForBundle(bundledTests) ? ('wouldCreateNew' | translate) : ('maximumTestCountForBundle' | translate) }}
                                                                @if (testBundlesService.canAddTestForBundle(bundledTests)) {
                                                                  <button
                                                                    class="button button--primary form_button"
                                                                    (click)="onNextTestCreate()">
                                                                    <span class="regular">{{ 'yes' | translate }}</span>
                                                                  </button>
                                                                }
                                                                <button
                                                                  class="button button--primary form_button"
                                                                  (click)="onStepOneComplete(true)">
                                                                  <span class="regular">{{ testBundlesService.canAddTestForBundle(bundledTests) ? ('submitBundle' | translate) : ('done' | translate) }}</span>
                                                                </button>
                                                              </div>
                                                            }
                                                            <div [hidden]="currentStep !== 2">
                                                              <br />
                                                              {{ 'providePatientContact' | translate }}
                                                              <br />
                                                              <app-input-wrapper
                                                                [control]="form.get('patient_email')"
                                                                label="{{ 'email' | translate }}"
                                                                identifier="email">
                                                                <input
                                                                  autocorrect="off"
                                                                  autocapitalize="none"
                                                                  class="form_control"
                                                                  type="email"
                                                                  name="email"
                                                                  id="email"
                                                                  formControlName="patient_email"
                                                                  (input)="onPatientEmailChange($event)">
                                                                </app-input-wrapper>
                                                                <app-input-wrapper
                                                                  [control]="form.get('patient_phone')"
                                                                  [hasPlaceholderOffset]="true"
                                                                  label="{{ 'phone' | translate }}">
                                                                  <ngx-mat-intl-tel-input
                                                                    class="form_control"
                                                                    [ngClass]="{ 'form_control--disabled': disabled }"
                                                                    [preferredCountries]="['us']"
                                                                    [enablePlaceholder]="true"
                                                                    [enableSearch]="true"
                                                                    formControlName="patient_phone">
                                                                  </ngx-mat-intl-tel-input>
                                                                </app-input-wrapper>
                                                                @if (currentStep === 2) {
                                                                  <button class="button button--primary form_button" (click)="onStepTwoComplete()" [disabled]="!isStepTwoValid()">
                                                                    <span class="regular">{{ 'next' | translate }}</span>
                                                                  </button>
                                                                }
                                                              </div>
                                                              <div [hidden]="currentStep !== 3">
                                                                @if (!isRecurringSelected) {
                                                                  {{ 'isRecurring' | translate }}
                                                                  <button id="recurring-bundle-yes-button" class="button button--primary form_button" (click)="onRecurringConfirm()">
                                                                    <span class="regular">{{ 'yes' | translate }}</span>
                                                                  </button>
                                                                  <button class="button button--primary form_button" (click)="onSubmit(form)">
                                                                    <span class="regular">{{ 'no' | translate }}</span>
                                                                  </button>
                                                                } @else {
                                                                  <app-input-wrapper
                                                                    [control]="form.get('period_in_days')"
                                                                    label="{{ 'periodInDays' | translate }}">
                                                                    <input class="form_control" type="number" min="1" max="999" formControlName="period_in_days" name="period_in_days">
                                                                  </app-input-wrapper>
                                                                  <app-input-wrapper
                                                                    [control]="form.get('end_date')"
                                                                    label="{{ 'endDate' | translate }}">
                                                                    <input
                                                                      class="form_control"
                                                                      [matDatepicker]="picker"
                                                                      [datePickerFormat]="preferencesService.defaultDateFormat.serverValue"
                                                                      [min]="minEndDate"
                                                                      formControlName="end_date"
                                                                      name="end_date">
                                                                      <mat-datepicker-toggle matSuffix [for]="picker" class="form_datepicker-icon">
                                                                      </mat-datepicker-toggle>
                                                                    </app-input-wrapper>
                                                                    <mat-datepicker #picker></mat-datepicker>
                                                                    <button (click)="onSubmit(form, true)" class="button button--primary form_button" [disabled]="!form.valid || !form.dirty">
                                                                      <span class="regular">{{ 'done' | translate }}</span>
                                                                    </button>
                                                                  }
                                                                </div>
                                                              </form>
                                                            }

                                                          </app-center-container>

                                                          @if (isLoading) {
                                                            <app-loader></app-loader>
                                                          }
